document.addEventListener('DOMContentLoaded', () => {
    const variantPickers = document.querySelectorAll('.product-block-variant-picker .variant-input input[data-single-option-selector]');
    
    variantPickers.forEach(variantPicker => {
        variantPicker.addEventListener('click', () => {
            setTimeout(() => {
                const variantSelector = document.querySelector('.product-block-buy-buttons select[x-ref="singleVariantSelector"]');
                const pdpVariantSku = document.querySelector('#pdpVariantSku');
                
                if (variantSelector && pdpVariantSku) {
                    const selectedOption = Array.from(variantSelector.options).find(option => option.hasAttribute('selected'));

                    if (selectedOption && selectedOption.hasAttribute('sku-data')) {
                        pdpVariantSku.innerHTML = selectedOption.getAttribute('sku-data');
                        pdpVariantSku.closest('#pdpVariantSkuBlock').classList.remove('invisible');
                    } else {
                        pdpVariantSku.innerHTML = '';
                        pdpVariantSku.closest('#pdpVariantSkuBlock').classList.add('invisible');
                    }
                }
            }, 10);
        });
    });
});
